import React, {useState, useEffect, useRef} from 'react'
import Slider1 from '../assets/bg-img1.jpg';
import Slider2 from '../assets/bg-img2.jpg';
import Slider3 from '../assets/bg-img3.jpg';
import Slider4 from '../assets/bg-img4.jpg';

import { MdArrowOutward, MdDashboard, MdInsights } from 'react-icons/md';
import { PiStrategy } from 'react-icons/pi';
import { CgPerformance } from 'react-icons/cg';
import { RiGraduationCapFill, RiSkull2Line } from 'react-icons/ri';
import { IoChatbubblesOutline } from 'react-icons/io5';
import AboutImg from '../assets/about-img1.jpg';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import ScrollAnimation from 'react-animate-on-scroll';
import { FaCheckCircle, FaCheckDouble } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
// import { SiLivechat, SiMarketo } from "react-icons/si";
// import 'animate.css/animate.min.css';
import priceBg from "../assets/price-bg.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';
import MyService from '../general/MyService';
import { TbNumber1Small, TbNumber2Small, TbNumber3Small } from "react-icons/tb";

const Home = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const serviceRef = useRef(null);
  // const chartRef = useRef(null);

   const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo === 'comparison') {
      const element = document.getElementById('comparison-section');
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);


  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/get-subscription-plan');
      if (response.ok) {
        const data = await response.json();
        setPlans(data);
      } else {
        console.error('Failed to fetch plans');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
    {/* slider section */}
<section className='px-md-4 px-3 mb-5'>

<div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="1500">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={Slider1} className="d-block w-100" alt="Slider" />
      <div className='carousel-content animate__animated animate__fadeInLeft animate__fast'>
        <div className='col-xl-7 col-lg-9 col-md-10 animate__animated animate__fadeInRight'>
        <span className='content-text'> Trade Journal </span> &nbsp;
        <p className='carousel-heading mt-3'>A Complete Trading Intelligence Platform Built for Consistent Performance</p>
        <p className='mb-4 text-light para-text'>In today’s fast-moving financial markets, success is not driven by luck—it is driven by information, discipline, and execution. Our platform is designed to bring all three together in one powerful ecosystem, helping traders make well-informed decisions with confidence and precision.
<span className='d-md-block d-none'><br />Whether you are an active intraday trader, a swing trader, or a long-term market participant, our tools and insights are built to support your journey toward consistent and sustainable trading performance.</span>
</p>
        <button className='carousel-btn animate__animated animate__pulse animate__infinite' onClick={() => navigate('/about')}>Get Free Trial <MdArrowOutward size={20} /></button>
      </div>
      </div>
    </div>


    <div className="carousel-item">
      <img src={Slider2} className="d-block w-100" alt="Slider" />
      <div className='carousel-content animate__animated animate__fadeInLeft animate__fast'>
        <div className='col-xl-7 col-lg-9 col-md-10 animate__animated animate__fadeInRight'>
        <span className='content-text'> News & Information </span> &nbsp;
        {/* <span className='content-text'>Journal</span> <span className='para-text text-light'>Market Insights</span> */}
        <p className='carousel-heading mt-3'>Market-Moving News With Deep Impact Analysis</p>
        <p className='mb-4 text-light para-text'>Markets react instantly to economic releases, geopolitical developments, and global financial events. We ensure you never miss what matters.
<span className='d-md-block d-none'><br />Our platform delivers real-time market, economic, and geopolitical news, enriched with professional analysis that goes beyond headlines. We compare current and previous data, allowing traders to clearly understand how expectations differ from actual outcomes.</span>
</p>
        <button className='carousel-btn' onClick={() => serviceRef.current.scrollIntoView({ behavior: "smooth" })}>Know More <MdArrowOutward size={20} /></button>
      </div>
      </div> </div>


    <div className="carousel-item">
      <img src={Slider3} className="d-block w-100" alt="Slider" />
      <div className='carousel-content animate__animated animate__fadeInLeft animate__fast'>
        <div className='col-xl-7 col-lg-9 col-md-10 animate__animated animate__fadeInRight'>
        <span className='content-text'> Market Insights </span> &nbsp;
        {/* <span className='content-text'>Journal</span> <span className='para-text text-light'>News</span> */}
        <p className='carousel-heading mt-3'>Advanced Market Insights & Institutional-Level Analysis</p>
        <p className='mb-4 text-light para-text'>Our Market Insight section is built to provide traders with clarity in complex market conditions. Using professional analytical frameworks, we identify critical price levels that define market direction.
<span className='d-md-block d-none'><br />You gain access to :-<br />
•	Key market rise and fall zones<br />
•	Professionally calculated support and resistance levels<br />
•	Clearly mapped high-probability buy and sell zones<br />
•	Forward-looking strategies for upcoming market sessions<br /><br />
Every insight is designed to support planned execution, helping traders avoid emotional decisions and react with confidence to evolving market conditions.
</span></p>
        <button className='carousel-btn' onClick={() => serviceRef.current.scrollIntoView({ behavior: "smooth" })}>Know More <MdArrowOutward size={20} /></button>
      </div>
      </div> </div>


    <div className="carousel-item">
      <img src={Slider4} className="d-block w-100" alt="Slider" />
      <div className='carousel-content animate__animated animate__fadeInLeft animate__fast'>
        <div className='col-xl-7 col-lg-9 col-md-10 animate__animated animate__fadeInRight'>
        <span className='content-text'> Educational Content </span> &nbsp;
        {/* <span className='content-text'>Journal</span> <span className='para-text text-light'>Educational Content</span> */}
        <p className='carousel-heading mt-3'>Strategy-Focused Learning Through Expert-Verified Educational Videos</p>
        <p className='mb-4 text-light para-text'>Successful trading requires a strategy that aligns with your personality and market conditions. Our platform provides an extensive library of educational video content, enabling traders to learn, practice, and apply proven methodologies.
<span className='d-md-block d-none'><br />What we offer :-<br />
•	A wide range of trading strategies for different market environments<br />
•	Step-by-step video explanations for easy understanding<br />
•	Practical insights into entry, exit, and risk management<br />
•	All strategies are tested, verified, and validated by our expert team<br /><br />
This ensures traders don’t rely on random signals but trade with structure, logic, and confidence.</span>
</p>
        <button className='carousel-btn'>Know More <MdArrowOutward size={20} /></button>
      </div>
      </div> </div>




  </div>
</div>

</section>
{/* slider section ends */}


{/* values section */}
<section className='value-bg py-md-5 py-4'>
  <div className='container'>

<div className='value-container p-2'>
<div className='row text-center cols-lg-5'>

<div className='col my-4'>
<MdInsights className='value-icon' size={75} />
<p className='fw-semibold mt-2 mb-0'>Quick Insights</p>
</div>

<div className='col my-4'>
<PiStrategy className='value-icon' size={75} />
<p className='fw-semibold mt-2 mb-0'>View Strategy</p>
</div>

<div className='col my-4'>
<CgPerformance className='value-icon' size={75} />
<p className='fw-semibold mt-2 mb-0'>Optimize Performance</p>
</div>

<div className='col my-4'>
<RiSkull2Line className='value-icon' size={75} />
<p className='fw-semibold mt-2 mb-0'>Risk Control</p>
</div>

<div className='col my-4'>
<IoChatbubblesOutline className='value-icon' size={75} />
<p className='fw-semibold mt-2 mb-0'>Live Chat</p>
</div>

</div>
{/* row ends */}

</div>

  </div>
  </section>
{/* values section ends */}


{/* about section */}
<section className='about-bg pb-5'>
<div className='container'>

<div className='row'>

<div className='col-lg-6 col-12'>
<img src={AboutImg} className='img-fluid rounded w-100 h-100' alt='About' />
</div>

<ScrollAnimation animateIn='animate__fadeInRight' className='col-lg-6 col-12 my-4' >
  <span className='fm-inter fw-semibold text-golden fs-5'>More About Us</span>
  <p className='mt-2 about-heading'>Trade Smarter. Analyze Deeper. Perform Better.</p>

<p className='para-text text-muted'><span className='fw-semibold'>Designed for Serious Traders. Built for Long-Term Growth.</span><br />Take control of your trading journey with a platform designed to help you analyze smarter, manage risk better, and trade with confidence in every market condition.<br />
Over time, a comprehensive performance dashboard is generated, providing deep insights such as :-</p>

<div className='row'>
<div className='col-6'><div className='bg-white rounded p-2 fw-semibold'><IoMdCheckmarkCircleOutline size={38} className='text-golden' /> Track	Performance trends by Days</div></div>
<div className='col-6'><div className='bg-white rounded p-2 fw-semibold'><IoMdCheckmarkCircleOutline size={38} className='text-golden' /> Behavioral patterns affecting profitability</div></div>
</div>
{/* inner row ends */}

<p className='para-text text-muted mt-3'>Our platform is more than a collection of tools—it is a complete trading intelligence system designed to support disciplined decision-making, continuous learning, and measurable improvement.
<br />By combining news intelligence, market insights, education, analytics, and community, we help traders shift from reactive trading to strategic execution.
</p>

<button className='about-btn' onClick={() => navigate('/about')}>Know More <MdArrowOutward size={20} /></button>
</ScrollAnimation>


</div>
{/* row ends */}

</div>
</section>
{/* about section ends */}


{/* counter section */}
<section className='pb-5 counter-bg'>
<div className='container'>

<hr className='my-0' />

<ScrollAnimation className='row mt-4' animateIn='animate__fadeInUp'>

<div className='col-lg-3 col-md-3 col-6 my-2'>
<div className='counter-area1'>
<div className='counter-area-inner'>
  <p className='counter-text my-0'>7+</p>
  <p className='counter-info fw-semibold'>Years Experience</p>
  </div>
  </div>
</div>

<div className='col-lg-3 col-md-3 col-6 my-2'>
<div className='counter-area'>
<div className='counter-area-inner' style={{backgroundColor: 'var(--golden2)'}}>
  <p className='counter-text my-0 text-light'>1000+</p>
  <p className='counter-info fw-semibold'>Happy Clients Nationwide</p>
  </div>
  </div>
</div>

<div className='col-lg-3 col-md-3 col-6 my-2'>
<div className='counter-area1'>
<div className='counter-area-inner'>
  <p className='counter-text my-0'>91.5%</p>
  <p className='counter-info fw-semibold'>Insights Accuracy</p>
  </div>
  </div>
</div>

<div className='col-lg-3 col-md-3 col-6 my-2'>
<div className='counter-area1'>
<div className='counter-area-inner'>
  <p className='counter-text my-0'>20K</p>
  <p className='counter-info fw-semibold'>Journals Recorded</p>
  </div>
  </div>
</div>



</ScrollAnimation>
{/* row ends */}


</div>
  </section>
{/* counter section ends*/}


<section  ref={serviceRef}><MyService />
</section>


{/* plans & pricing */}

{plans.length > 0 && 
<section className='p-2'>
<div
  className="faq-bg"
style={{ backgroundImage: `url(${priceBg})` }}>

  <div className='faq-bg-inner py-5 text-center' style={{background: 'transparent'}}>
  <div className='px-md-4 px-5'>


<ScrollAnimation className='row' animateIn='animate__fadeInUp'>
  <span className='fm-inter fw-semibold text-golden fs-5'>Subscribe Now</span>
  <p className='mt-2 about-heading text-light'>Our Plans & Pricing</p>
</ScrollAnimation>

<ScrollAnimation className='row' animateIn='animate__fadeInLeft'>

            {plans.length > 0 ? (
              plans.map((sp) => (
                <div className="col-lg-3 col-md-6 col-12 my-2" key={sp.id}>
                  <div className="plan-card p-3 bg-white">
                    <p className='text-light fw-bold fm-inter'>
                      <span className='fs-2'>₹{sp.offer_price}</span> / 
                      <span className='para-text'>{sp.duration} days</span>
                      {sp.offer_price !== sp.price && (
                        <span className='ps-3 fs-5 text-decoration-line-through'>₹{sp.price}</span>
                      )}
                    </p>
                    <p className="page-heading">{sp.plan_name}</p>
                    <p className="fw-semibold">PLAN CODE: {sp.plan_code}</p>
                    <p>{sp.description}</p>
                    <p className='para-text fw-semibold'>{sp.trial_days} days trial available</p>

                  </div>
                </div>
              ))
            ) : (
              <p>No Plans Created yet.</p>
            )}

</ScrollAnimation>
{/* row ends */}

        {/* <button className='carousel-btn animate__animated animate__pulse animate__infinite mt-4' onClick={() => navigate('/about')}>Free Trial for 3 Days <MdArrowOutward size={20} /></button> */}

</div>
</div>
</div>
</section>
}
{/* plans & pricing ends */}


{/* how it works section */}
<section className='my-5'>
  <div className='container text-center'>

  <span className='fm-inter fw-semibold text-golden fs-5'>Simple Process</span>
  <p className='mt-2 about-heading'>How Trade Intell works</p>

<div className='row'>

<div className='col-lg-4 col-md-4 col-12 my-2'>
<TbNumber1Small size={70} className='service-icon' />
<p className='mt-4 fm-inter fw-semibold'>Get App & Create Account</p>
<p className='text-muted'>Download app and sign up in minutes to get started. Create your account and unlock access to all features with a 3 Days free Trial.</p>
</div>

<div className='col-lg-4 col-md-4 col-12 my-2'>
<TbNumber2Small size={70} className='service-icon' />
<p className='mt-4 fm-inter fw-semibold'>Prepare Record & Add</p>
  <p className='text-muted'>Organize your details, prepare required records, and easily add them to the system with a simple, guided process.</p>
</div>


<div className='col-lg-4 col-md-4 col-12 my-2'>
<TbNumber3Small size={70} className='service-icon' />
<p className='mt-4 fm-inter fw-semibold'>Review & Improve</p>
<p className='text-muted'>Review your journal, track progress, and make improvements with helpful insights to achieve better results over time.</p>
  
</div>


</div>
{/* row ends */}


  </div>
</section>

{/* how it works section ends */}


{/* comparision chart section */}
<section className='py-md-5 py-4'>
  <div className='container'>

<div className='value-container p-4'>
<div className='row' >

  <span className='fm-inter fw-semibold text-golden fs-5'>Comparison</span>
  <p className='mt-2 about-heading'>Trade Intell vs. Other Platforms</p>


<div className='table-responsive'  id="comparison-section">
<table className='table border w-100 fm-inter'>

<thead className='bg-dark text-light'>
  <th className='p-3'>Features</th>
  <th className='p-3'>Trade Intell</th>
  <th className='p-3'>vs. Others</th>
</thead>

<tbody>

<tr>
  <td className='p-3'>Journal Records</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'>Difficult to Maintain</td>
</tr>

<tr>
  <td className='p-3'>Strategy Analysis</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Risk Management Tools</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Data Analysis</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
</tr>

<tr>
  <td className='p-3'>Custom Reports</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Av. Risk Reward Ratio</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'>Manual</td>
</tr>

<tr>
  <td className='p-3'>Emotion Tracking</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Affordable Plans</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>


<tr>
  <td className='p-3'>Psychology Tracking</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Live Chat</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Market News & Insights</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Index Insights</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Trade Execution Analysis</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Journal Screenshots Allowed</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Leader Board</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>

<tr>
  <td className='p-3'>Anytime Access</td>
  <td className='p-3'><FaCheckCircle size={24} color='green' /></td>
  <td className='p-3'><FaCircleXmark size={24} color='red' /></td>
</tr>


</tbody>


</table>
</div>


</div>
</div>


  </div>
  </section>
{/* comparision chart section ends */}


{/* testimonials section */}
<section className='my-5'>
  <div className='container text-center'>

<ScrollAnimation animateIn='animate__fadeInUp'>
  <span className='fm-inter fw-semibold text-golden fs-5'>Reviews</span>
  <p className='mt-2 about-heading'>Our Client Testimonials</p>
</ScrollAnimation>

{/* <ScrollAnimation className='row text-center' animateIn='animate__fadeInRight'>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<p>“The trade journaling feature helped me understand my mistakes and improve my consistency.”</p>
<p className='fm-inter fw-semibold'>— Asish</p>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
  <p>“Market insights and news updates keep me informed and confident before entering trades.”</p>
<p className='fm-inter fw-semibold'>— Muskan</p>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
  <p>“Educational videos are easy to follow and perfect for both beginners & experienced traders.”</p>
<p className='fm-inter fw-semibold'>— Vikas</p>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
  <p>“Having records, insights, and news—in one place has completely improved my trading routine.”</p>
<p className='fm-inter fw-semibold'>— Sai</p>
</div>

</ScrollAnimation> */}
{/* <ScrollAnimation animateIn="animate__fadeInRight"> */}
  <Swiper
    modules={[Autoplay, Pagination]}
    spaceBetween={10}
    slidesPerView={1}
    autoplay={{ delay: 3000 }}
    // pagination={{ clickable: true }}
    breakpoints={{
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
      1200: { slidesPerView: 4 },
    }}
    className="text-center"
  >
    <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“In & Out Journaling completely changed how I trade. Seeing my entries, exits, & metrics in one place helped me cut bad habits fast.”</p>
      <p className="fm-inter fw-semibold">— Asish</p>
    </SwiperSlide>

    <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“Being able to track multiple indices from a single dashboard saves so much time. I can switch markets instantly without losing context.”</p>
      <p className="fm-inter fw-semibold">— Muskan</p>
    </SwiperSlide>

    <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“The educational content is clear, & actually usable. The step-by-step strategy videos helped me understand risk management.”</p>
      <p className="fm-inter fw-semibold">— Vikas</p>
    </SwiperSlide>

    <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“I stopped reacting to market noise once I started using the news and insights section. The data-backed analysis gives real clarity.”</p>
      <p className="fm-inter fw-semibold">— Sai</p>
    </SwiperSlide>

        <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“The live chat feels like trading with a smart community. Real-time idea exchange helped me validate setups before entering trades.”</p>
      <p className="fm-inter fw-semibold">— Sushmita</p>
    </SwiperSlide>


        <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“What I love most is the digital dashboard. Everything—from performance analytics to key levels—is clean, fast, and easy to read.”</p>
      <p className="fm-inter fw-semibold">— Unknown</p>
    </SwiperSlide>

        <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“Trade journaling plus analytics showed me exactly where I was overtrading. That awareness alone improved my discipline.”</p>
      <p className="fm-inter fw-semibold">— Unknown</p>
    </SwiperSlide>

        <SwiperSlide className='bg-light p-2 rounded-3 shadow-md'>
      <p>“Combining education, analytics, and real-time news in one platform makes decision-making much more structured and stress-free.”</p>
      <p className="fm-inter fw-semibold">— Shreya</p>
    </SwiperSlide>


  </Swiper>
{/* </ScrollAnimation> */}

{/* row ends */}


  </div>
</section>
{/* testimonials section ends */}



{/* faq section */}
<section className='p-2'>
  <div className='faq-bg'>
  <div className='faq-bg-inner py-5'>
  <ScrollAnimation className='container' animateIn='animate__fadeInLeft'>

  <span className='fm-inter fw-semibold text-golden fs-5'>FAQs</span>
  <p className='mt-2 about-heading'>Questions In Mind</p>



<div className="accordion col-lg-7 accordion-flush" id="accordionExample">
  <div className="accordion-item rounded-top">
    <h2 className="accordion-header" id="headingOne">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
01. &nbsp;How do you provide the insights?
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div className="accordion-body para-text text-muted">
All the market levels and the insights provided are extracted by our team of years of experienced traders.      </div>
    </div>
  </div>
  <div className="accordion-item rounded-top">
    <h2 className="accordion-header" id="headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        02. &nbsp;How long would it take to see results/profits?
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div className="accordion-body para-text text-muted">
You can see the results in your dashboard immediately after you enter the trade details.</div>    </div>
  </div>
  <div className="accordion-item rounded-top">
    <h2 className="accordion-header" id="headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        03. &nbsp;How does the platform ensure fund security and data protection?
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <div className="accordion-body para-text text-muted">
The platform uses industry-grade encryption, secure authentication, and regulated payment gateways to protect your funds and personal data.
Advanced security protocols, regular audits, and strict access controls ensure your information stays private and your transactions remain safe.
</div>
    </div>
  </div>

  <div className="accordion-item rounded-top">
    <h2 className="accordion-header" id="headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        04. &nbsp;How can I track performance and analyse past trades to improve consistency?
      </button>
    </h2>
    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
      <div className="accordion-body para-text text-muted">
You can track your performance in the provided dashboard and check the mistakes made in previous trades to improve your trade quality.</div>
    </div>
  </div>


    <div className="accordion-item rounded-top">
    <h2 className="accordion-header" id="headingFive">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
        05. &nbsp;Can I get a refund on the deposited amount?
      </button>
    </h2>
    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
      <div className="accordion-body para-text text-muted">
You cannot get a refund once deposited into the account.</div>
    </div>
  </div>


</div>


  </ScrollAnimation>
  </div>
  </div>
</section>
{/* faq section ends */}


      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default Home